import React from 'react';
import {Button, Icons} from '@xpertdox_js/xdcomponents';

const styles = {
  container: {
    padding: 5,
    fontSize: 13
  },
  btn: {
    padding: 0,
    background: 'none',
    color: 'black',
    fontWeight: 'bold'
  },
  icon: {
    height: 10,
    width: 10,
    fill: 'black'
  },

}

const Collapsable = (props) => {
  const [toggle, setToggle] = React.useState(props.default);
  return <div style={styles.container}>
    <Button styles={styles.btn} onClick={() => setToggle(!toggle)}><span><Icons icon='chevron' style={{...styles.icon, transform: toggle ? 'rotate(0deg)' : 'rotate(270deg)'}} /> {props.title}</span></Button>
    {(toggle && props.list) && <ul>
      {props.list.map((item, i) => <li key={i}>{item}</li>)}
    </ul>}
  </div>
}

export default Collapsable;
